<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        fluid
        fill-height>
        <v-layout
          align-center
          justify-center
          column>
          <v-spacer/>
          <v-flex>
            <v-card
              style="width: 350px;"
              class="elevation-12">
              <v-toolbar
                dark
                color="primary">
                <v-toolbar-title>清關系統登錄</v-toolbar-title>
                <v-spacer/>
              </v-toolbar>
              <v-card-text>
                <div v-if="useDingding">
                  <!-- <v-layout
                    class="ma-0"
                    align-center>
                    <div class="blue--text title">
                      钉钉扫码登录
                    </div>
                    <v-spacer/>
                    <v-btn
                      flat
                      @click="useDingding = false">使用账号密码登录</v-btn>
                  </v-layout> -->

                  <div class="text-xs-center">
                    <div id="dd_login_container"/>
                  </div>
                </div>
                <template v-else>
                  <v-form>
                    <v-text-field
                      v-model="user.loginName"
                      prepend-icon="person"
                      name="login"
                      label="用戶名"
                      type="text"
                    />
                    <v-text-field
                      v-model="user.password"
                      prepend-icon="lock"
                      name="password"
                      label="密碼"
                      type="password"
                      @keyup.enter="login"
                    />
                  </v-form>

                  <v-layout
                    class="ma-0"
                    align-center>
                    <!-- <v-btn
                      flat
                      @click="useDingding = true">
                      <div style="color: #1a92f6;line-height: 26px;">
                        <i
                          class="iconfont icondingtalk"
                          style="font-size: 20px;vertical-align: bottom;"/> 钉钉扫码登录
                      </div>
                    </v-btn> -->
                    <v-spacer/>
                    <v-btn
                      :loading="loading"
                      :deisabled="loading"
                      color="primary"
                      class="ma-0"
                      @click.stop="login"
                    >送出</v-btn>
                  </v-layout>
                </template>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-spacer/>
          <div
            style="width: 80vw"
            class="grey--text text-xs-center">
            創造這個免費的系統只希望能幫助到一些人從重複繁重的工作中解放，做人類應該做的事情：邏輯思維與情感。感謝我的偶象Steve jobs那句“活著只為改變世界”改變了我的人生觀。
          </div>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import {getParameterByName} from '@/utils/index'

const appid = 'dingoakihkvnbhimozqn9e'
const rUrl = encodeURIComponent('https://api.jyb.com.tw/user/v1frontend/ding-talk/callback-login')
export default {
  data () {
    return {
      loading: false,
      user: {
        loginName: '',
        password: ''
        // loginName: '0900001000',
        // password: 'abc123'

        //   xianyu      0900001249
        // abc123

        // 華宏賬號  0900001399  huah1399

        //         清关系统查全部数据的账号
        // 0900085288
        // kkr5288

        //         清關系統 - 聯帝
        // 0900001718
        // liandi1718
        // 東風 0900001609   dfeng1609
        // 中信賬號  0900001575  zxin1575

        // 台中中信 0900001258  zxintz1258
        // 東華 0900001248  dhua1248
        // uid 100129  0901609007  0901609007
        // 台中立騰 0900001254   litengtz1254
      },
      useDingding: false,
    }
  },
  watch: {
    useDingding () {
      if (this.useDingding) {
        this.showDDLoginQr()
      }
    },
  },
  mounted () {
    const code = getParameterByName('code')
    if (code) {
      this.loginDD(code)
    }

    if (this.useDingding) {
      this.showDDLoginQr()
    }
    window.addEventListener('message', this.handleMessage, false)
  },
  destroyed () {
    window.removeEventListener('message', this.handleMessage, false)
  },
  methods: {
    gotoDDLogin () {
      const url = `https://oapi.dingtalk.com/connect/qrconnect?appid=${appid}&response_type=code&scope=snsapi_login&state=beLogin&redirect_uri=${rUrl}`
      window.open(url)
    },
    async showDDLoginQr () {
      await this.$nextTick()
      // const url = encodeURIComponent(location.href)
      window.DDLogin({
        id: 'dd_login_container',
        goto: encodeURIComponent(`https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appid}&response_type=code&scope=snsapi_login&state=beLogin&redirect_uri=${rUrl}`), // 请参考注释里的方式
        style: 'border:none;background-color:#FFFFFF;',
        width: '300',
        height: '300'
      })
    },
    handleMessage () {
      const origin = event.origin
      if (origin === 'https://login.dingtalk.com') { // 判断是否来自ddLogin扫码事件。
        const loginTmpCode = event.data
        // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了

        console.log('loginTmpCode', loginTmpCode)
        location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${appid}&response_type=code&scope=snsapi_login&state=beLogin&redirect_uri=${rUrl}&loginTmpCode=${loginTmpCode}`
        this.loginDD(loginTmpCode)
      }
    },
    async loginDD (code) {
      try {
        this.loading = true
        let res = await this.$store.dispatch('user/login', {
          username: `dingtalk,${code}` // (eg. dingtalk,741a011b85a830a2b4b4b793b71f022d)
        })
        console.log(res)
      } finally {
        this.loading = false
      }
    },
    async login () {
      try {
        this.loading = true
        const res = await this.$store.dispatch('user/login/login', this.user)
        if (res.data.model.uid) {
          this.$router.push({name: 'Home'})
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/_layout/Login.vue